import { jsqPrivacyPolicy } from "./constants";
import { type PrivacyPolicy, type ArenaItem } from "./types";

export const generateLeftHandSideList = (
  arenasList: ArenaItem[],
  isAuthenticated: boolean,
  token: string,
  currentArena: string,
  showNav: boolean,
  singleArenaDomain?: string,
) => {
  let basePath;
  if (isAuthenticated) {
    basePath = singleArenaDomain ? `i/${singleArenaDomain}` : "lp";
  } else {
    basePath = "networked_portal";
  }
  const queryParam = token.length > 0 ? `?activation=${token}` : "";
  const termsAndPrivacyPath = showNav ? "terms-and-privacy" : "terms-and-privacy-nn";
  const getArenasList = arenasList
    .filter((obj) => obj.clientPrivacyPolicy || obj.clientTos)
    .map((obj) => {
      return {
        title: obj.name,
        to: `/${basePath}/${termsAndPrivacyPath}/${obj.domain}${queryParam}`,
        isActive: () => obj.domain === currentArena,
      };
    });
  const leftHandSideArray = [
    {
      title: "Juniper Square",
      to: `/${basePath}/${termsAndPrivacyPath}/jsq${queryParam}`,
      isActive: () => currentArena === "jsq",
    },
  ].concat(getArenasList);
  return leftHandSideArray;
};

type PrivacyPolicyInputs = {
  arenasList: ArenaItem[];
  jsqTou: JSX.Element;
};

export const generatePrivacyPolicies = ({ arenasList, jsqTou }: PrivacyPolicyInputs) => {
  const jsqPrivacyPolicies: PrivacyPolicy = {
    jsq: {
      tou: jsqTou,
      pp: jsqPrivacyPolicy,
    },
  };
  arenasList.forEach((obj) => {
    if (obj.clientPrivacyPolicy || obj.clientTos) {
      jsqPrivacyPolicies[obj.domain] = {
        tou: obj.clientTos || "",
        pp: obj.clientPrivacyPolicy || "",
      };
    }
  });
  return jsqPrivacyPolicies;
};
